export class DataExistsException extends Error {

}